import { render, staticRenderFns } from "./welfareNew.vue?vue&type=template&id=a216ab44&scoped=true"
import script from "./welfareNew.vue?vue&type=script&lang=js"
export * from "./welfareNew.vue?vue&type=script&lang=js"
import style0 from "./welfareNew.vue?vue&type=style&index=0&id=a216ab44&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a216ab44",
  null
  
)

export default component.exports